import { css } from "@emotion/css";
import React from "react";
import {
    parseStyle,
    decodeStyle,
    mobile,
    tablet,
    isHidden,
} from "../../../juntion";
import { useAction } from "../../../hooks";
import log from "cslog";
import classNames from "classnames";

function Button({ id, db, dydb, gs, device }) {
    const { performAction } = useAction();
    const data = db[id];

    const ps = parseStyle(data, gs, data.cstate);

    if (isHidden(ps.classes, device)) {
        return null;
    }

    const tabletStyle = tablet(device) ? ps.tablet : {};
    const mobileStyle = mobile(device) ? ps.mobile : {};

    let input = ps.input;
    input = { ...input, ...(tablet(device) && ps.itablet) };
    input = { ...input, ...(mobile(device) && ps.imobile) };

    const btnData = input.buttonType;

    const icon = btnData?.type !== "text" && (
        <i
            className={btnData.params.icon.value}
            style={{
                zoom: 0.9,
                marginRight:
                    btnData?.params?.text && !btnData?.params?.icon_right
                        ? "1rem"
                        : "auto",
                marginLeft:
                    btnData?.params?.text && btnData?.params?.icon_right
                        ? "1rem"
                        : "auto",
            }}
        ></i>
    );

    const action = input.action;

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
            }}
        >
            <button
                // className={input.hoverAnimation}
                className={classNames(
                    input.hoverAnimation,
                    css({
                        ...decodeStyle(ps.fixStyle, gs),
                        ...decodeStyle(ps.style, gs),
                        // alignSelf: "stretch",
                        alignSelf: input.buttonAlign,
                        // alignSelf: "flex-start",
                        textTransform: btnData?.params?.uppercase
                            ? "uppercase"
                            : "none",
                        gap: "1.5rem",
                        fontWeight: input.bold ? "bold" : "normal",
                        fontSize: input.size || "12px",
                        cursor: "pointer",
                        margin: "10px",
                        "&:hover": {
                            ...decodeStyle(ps.style__hover || {}, gs),
                        },
                        "&:active": {
                            ...decodeStyle(ps.style__selected || {}, gs),
                        },
                    })
                )}
                // onClick={() => performAction(action)}
                onClick={(e) => {
                    e.stopPropagation();
                    performAction({
                        ...action,
                        dydb: dydb,
                    });
                }}
            >
                {btnData?.params?.icon && !btnData.params.icon_right && icon}
                {btnData?.params?.text && btnData.params.text}
                {btnData?.params?.icon && btnData.params.icon_right && icon}
            </button>
        </div>
    );
}

export default Button;
